import { atom } from 'jotai';

import { mapReadingRefsToSubscriptionIdentifiers } from '@/features/equipment-browser/subscriptions/map-to-subscription-identifiers';

import { equipmentResponseAtom } from './equipment-response.state';
import {
  getActionComponentIdentifiers,
  getDefrostScheduleIdentifiers,
  getRelatedDevicesIdentifiers,
} from './identifiers.helpers';

/**
 * readingIdentifiersAtom
 * Maintains the computed list of subscription identifiers for readings.
 *
 * Extracts the reading identifiers from the equipment response atom
 * and maps them to the subscription identifiers.
 */
export const readingIdentifiersAtom = atom((get) => {
  const response = get(equipmentResponseAtom);

  if (!response) return [];

  const actionComponentReadingsRefs = getActionComponentIdentifiers(
    response?.actionComponents,
    false
  );

  const displayReadingsRefs = response?.displayMetrics?.map((reading) => reading.ref) ?? [];

  const defrostScheduleReadingsRefs = getDefrostScheduleIdentifiers(
    response?.defrostScheduleConfig,
    false
  );

  const relatedDeviceReadingsRefs = getRelatedDevicesIdentifiers(response?.relatedDevices, false);

  return [
    ...actionComponentReadingsRefs,
    ...mapReadingRefsToSubscriptionIdentifiers(displayReadingsRefs, 'displayMetrics'),
    ...defrostScheduleReadingsRefs,
    ...relatedDeviceReadingsRefs,
  ];
});
readingIdentifiersAtom.debugLabel = 'readingIdentifiersAtom';
